<template>
    <div id='my_dataviz' style="width: 800px"></div>
</template>

<script>
import * as d3 from 'd3';

export default {
  name: 'Chart',
  props: {
    score: String,
  },
  data() {
    return {
      stats: [
        { x: 14, y: 1 },
        { x: 16, y: 5 },
        { x: 17, y: 4 },
        { x: 18, y: 12 },
        { x: 19, y: 12 },
        { x: 20, y: 23 },
        { x: 21, y: 31 },
        { x: 22, y: 31 },
        { x: 23, y: 61 },
        { x: 24, y: 83 },
        { x: 25, y: 84 },
        { x: 26, y: 109 },
        { x: 27, y: 137 },
        { x: 28, y: 150 },
        { x: 29, y: 217 },
        { x: 30, y: 227 },
        { x: 31, y: 255 },
        { x: 32, y: 176 },
        { x: 33, y: 327 },
        { x: 34, y: 353 },
        { x: 35, y: 384 },
        { x: 36, y: 372 },
        { x: 37, y: 453 },
        { x: 38, y: 479 },
        { x: 39, y: 499 },
        { x: 40, y: 513 },
        { x: 41, y: 461 },
        { x: 42, y: 463 },
        { x: 43, y: 493 },
        { x: 44, y: 485 },
        { x: 45, y: 456 },
        { x: 46, y: 464 },
        { x: 47, y: 460 },
        { x: 48, y: 400 },
        { x: 49, y: 450 },
        { x: 50, y: 453 },
        { x: 51, y: 352 },
        { x: 52, y: 296 },
        { x: 53, y: 276 },
        { x: 54, y: 301 },
        { x: 55, y: 245 },
        { x: 56, y: 244 },
        { x: 57, y: 186 },
        { x: 58, y: 165 },
        { x: 59, y: 131 },
        { x: 60, y: 128 },
        { x: 61, y: 113 },
        { x: 62, y: 93 },
        { x: 63, y: 67 },
        { x: 64, y: 76 },
        { x: 65, y: 57 },
        { x: 66, y: 43 },
        { x: 67, y: 41 },
        { x: 68, y: 23 },
        { x: 69, y: 20 },
        { x: 70, y: 14 },
        { x: 71, y: 14 },
        { x: 72, y: 9 },
        { x: 73, y: 7 },
        { x: 74, y: 4 },
        { x: 75, y: 5 },
        { x: 76, y: 2 },
        { x: 77, y: 2 },
        { x: 78, y: 1 },
        { x: 79, y: 1 },
        { x: 80, y: 0 },
        { x: 81, y: 0 },
        { x: 82, y: 0 },
        { x: 83, y: 0 },
        { x: 84, y: 0 },
        { x: 85, y: 0 },
        { x: 86, y: 0 },
        { x: 87, y: 0 },
        { x: 88, y: 0 },
        { x: 89, y: 0 },
        { x: 90, y: 0 },
      ],
    };
  },
  mounted() {
    this.genChart();
  },
  methods: {
    genChart() {
      const self = this;
      // set the dimensions and margins of the graph
      const margin = {
        top: 10, right: 30, bottom: 60, left: 60,
      };
      const width = 760 - margin.left - margin.right;
      const height = 400 - margin.top - margin.bottom;

      // append the svg object to the body of the page
      const svg = d3.select('#my_dataviz')
        .append('svg')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)
        .append('g')
        .attr('transform',
          `translate(${margin.left},${margin.top})`);

      const result = this.stats.reduce((sum, { y }) => sum + y, 0);

      // Read the data
      // Add X axis --> it is a date format
      const x = d3.scaleLinear()
        .domain([14, 90])
        .range([0, width]);
      svg.append('g')
        .attr('transform', `translate(0,${height})`)
        .call(d3.axisBottom(x));

      svg.append('text')
        .attr('class', 'x label')
        .attr('text-anchor', 'end')
        .attr('x', width)
        .attr('y', height - 6)
        .text('Similarity score');

      // Add Y axis
      const y = d3.scaleLinear()
        .domain([0, 4.5])
        .range([height, 0]);
      svg.append('g')
        .call(d3.axisLeft(y));

      svg.append('text')
        .attr('class', 'y label')
        .attr('text-anchor', 'end')
        .attr('y', 6)
        .attr('dy', '.75em')
        .attr('transform', 'rotate(-90)')
        .text('Frequency (%)');

      // gridlines in x axis function
      const makeXgridlines = function makeXgridlines() {
        return d3.axisBottom(x)
          .ticks(10);
      };

      // gridlines in y axis function
      const makeYgridlines = function makeYgridlines() {
        return d3.axisLeft(y)
          .ticks(10);
      };

      // Add the line
      let line = svg
        .append('path')
        .attr('id', 'line')
        .datum(this.stats)
        .attr('fill', 'none')
        .attr('stroke', '#660000')
        .attr('stroke-width', 2.5)
        .attr('d', d3.line()
          .curve(d3.curveBasis)
          .x((d) => x(d.x))
          .y((d) => y(100 * (d.y / result))));

      // add the X gridlines
      svg.append('g')
        .attr('id', 'line')
        .attr('class', 'grid')
        .attr('transform', `translate(0,${height})`)
        .call(makeXgridlines()
          .tickSize(-height)
          .tickFormat(''))
        .style('opacity', '0.3');

      // add the Y gridlines
      svg.append('g')
        .attr('class', 'grid')
        .call(makeYgridlines()
          .tickSize(-width)
          .tickFormat(''))
        .style('opacity', '0.3');

      d3.select('svg').append('text')
        .attr('x', width / 2 + 50)
        .attr('y', height + 40)
        .style('text-anchor', 'middle')
        .style('font-size', '10')
        .text('Data Collected using the Labelled Faces in the Wild dataset');

      // Mouse Thing
      // append a g for all the mouse over nonsense
      const mouseG = svg.append('g')
        .attr('class', 'mouse-over-effects');

      // this is the moving vertical line
      mouseG.append('path')
        .attr('class', 'mouse-line')
        .style('stroke', 'black')
        .style('stroke-width', '1px')
        .style('opacity', '0');

      // this.plotLine(self.$props.score, height, x);
      // Add a static vertical line
      d3.select('.mouse-over-effects')
        .append('path')
        .attr('class', 'staticline')
        .style('stroke', 'black')
        .style('stroke-width', '2px')
        .style('opacity', '1')
        .attr('d', () => {
          let d = `M${x(self.$props.score)},${height}`;
          d += ` ${x(self.$props.score)},${0}`;
          return d;
        })
        .style('stroke-dasharray', ('3, 3'));

      // keep a reference to all our lines
      line = document.getElementById('line');

      // here's a g for each circle and text on the line
      const mousePerLine = mouseG.selectAll('.mouse-per-line')
        .data([{
          name: 'main',
          values: this.stats,
        }])
        .enter()
        .append('g')
        .attr('class', 'mouse-per-line');

      // the circle
      mousePerLine.append('circle')
        .attr('r', 4)
        .style('stroke', '#990000')
        .style('fill', '#990000')
        .style('stroke-width', '1px')
        .style('opacity', '0');

      // the text
      mousePerLine.append('text')
        .attr('transform', 'translate(10,3)');

      // rect to capture mouse movements
      mouseG.append('svg:rect')
        .attr('id', 'rectlol')
        .attr('width', width)
        .attr('height', height)
        .attr('fill', 'none')
        .attr('pointer-events', 'all')
        .on('mouseout', () => { // on mouse out hide line, circles and text
          d3.select('.mouse-line')
            .style('opacity', '0');
          d3.selectAll('.mouse-per-line circle')
            .style('opacity', '0');
          d3.selectAll('.mouse-per-line text')
            .style('opacity', '0');
        })
        .on('mouseover', () => { // on mouse in show line, circles and text
          d3.select('.mouse-line')
            .style('opacity', '0.75');
          d3.selectAll('.mouse-per-line circle')
            .style('opacity', '1');
          d3.selectAll('.mouse-per-line text')
            .style('opacity', '1');
        })
        .on('mousemove', (event) => { // mouse moving over canvas
          const mouse = event;

          // move the vertical line
          d3.select('.mouse-line')
            .attr('d', () => {
              let d = `M${mouse.pageX - document.getElementById('rectlol').getBoundingClientRect().x},${height}`;
              d += ` ${mouse.pageX - document.getElementById('rectlol').getBoundingClientRect().x},${0}`;
              return d;
            });

          // position the circle and text
          d3.selectAll('.mouse-per-line')
            .attr('transform', function r() {
              const realpos = mouse.pageX - document.getElementById('rectlol').getBoundingClientRect().x;

              // console.log(this.$props.score);
              let beginning = 0;
              let end = line.getTotalLength();
              let target = null;
              let pos;

              // eslint-disable-next-line no-constant-condition
              while (true) {
                target = Math.floor((beginning + end) / 2);
                pos = line.getPointAtLength(target);
                if ((target === end || target === beginning) && pos.x !== realpos) {
                  break;
                }
                if (pos.x > realpos) end = target;
                else if (pos.x < realpos) beginning = target;
                else break; // position found
              }

              // update the text with y value
              d3.select(this).select('text')
                .text(y.invert(pos.y).toFixed(2));

              // return position
              return `translate(${realpos},${pos.y})`;
            });
        });
    },
    plotLine(score, x) {
      d3.select('.staticline')
        .transition()
        .duration(1000)
        .attr('d', () => {
          let d = `M${x(score)},${330}`;
          d += ` ${x(score)},${0}`;
          return d;
        })
        .style('opacity', score > 14 ? '1' : '0');
    },
  },
};
</script>
